import React, { useState } from "react";
import { fetchAudit } from "../../api/auditApi";
import { Log } from "../../models/Log";
import ExpandableItemsList from "../../components/lists/ExpandableItemsList";
import { useQuery } from "@tanstack/react-query";
import DatePicker from "react-date-picker";

const PAGE_SIZE = 10;

const AuditComponent: React.FC = () => {
  const [selectedGroup, setSelectedGroup] = useState<Log[] | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [currentPage, setCurrentPage] = useState(1);

  const { data: groupedData = [], isFetching } = useQuery<Log[][]>(
    ["AuditLogs", selectedDate, currentPage],
    () => fetchAudit(selectedDate || new Date(), currentPage, PAGE_SIZE)
  );

  const handleBackToGroups = () => {
    setSelectedGroup(null);
  };

  if (isFetching) return <>Loading...</>;

  return (
    <div className="mx-auto max-w-7xl sm:px-6 mt-3 lg:px-8">
      <div className="mb-4">
        <label className="block text-[10px] font-semibold uppercase tracking-[0.06em] text-[var(--sc-muted)] mb-2">
          Select Date
        </label>
        <DatePicker
          format="dd/MM/y"
          value={selectedDate}
          onChange={(date) => setSelectedDate(date as Date)}
        />
      </div>
      {selectedGroup ? (
        <div>
          <button onClick={handleBackToGroups} className="mb-4 text-[#F4A832] hover:text-[#e09620]">
            Back to Groups
          </button>
          <ExpandableItemsList
            data={selectedGroup.map((log) => ({
              id: log.id,
              name: log.action || "Unknown Action",
              description: "",
              oldValues: log.oldValues,
              newValues: log.newValues,
              created: new Date(log.created),
              createdBy: log.createdBy,
              edited: new Date(log.edited),
              EditedBy: log.editedBy,
              resourceId: log.resourceId,
              tableName: log.tableName,
              correlationId: log.correlationId,
            }))}
            isLoading={isFetching}
            urlPrefix="/audit/"
          />
        </div>
      ) : (
        <>
          <ExpandableItemsList
            data={groupedData.map((group, index) => ({
              id: index.toString(),
              name: `${group.length} Zmiany w ${[
                ...new Set(group.map((log) => log.tableName)),
              ].join(", ")} przez ${group[0]?.createdBy}`,
              description: `Data ${new Date(
                group[0]?.created
              ).toLocaleString()}\n`,
              oldValues: "",
              newValues: "",
              created: new Date(group[0]?.created),
              createdBy: group[0]?.createdBy,
              edited: new Date(group[0]?.edited),
              EditedBy: group[0]?.editedBy,
              resourceId: group[0]?.resourceId,
              tableName: group[0]?.tableName,
              correlationId: group[0]?.correlationId,
            }))}
            isLoading={isFetching}
            urlPrefix="/audit/"
            onItemClick={(item) =>
              setSelectedGroup(groupedData[parseInt(item.id)])
            }
          />
          <div className="p-3 flex items-center gap-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 rounded border border-[var(--sc-border)] text-sm disabled:opacity-40 hover:bg-[var(--sc-bg)]"
            >
              ‹ Poprzednia
            </button>
            <span className="text-sm text-[var(--sc-muted)]">Strona {currentPage}</span>
            <button
              onClick={() => setCurrentPage((p) => p + 1)}
              className="px-3 py-1 rounded border border-[var(--sc-border)] text-sm hover:bg-[var(--sc-bg)]"
            >
              Następna ›
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AuditComponent;
